module.exports = __webpack_public_path__ + "img/public/SiteIcons/languageChangeIcon.svg?92b6201b";